module.exports = __webpack_public_path__ + "img/signup-graphic.c9d513dc.webp";